const LogOut = () => (
  <>
    <path
      fill="currentColor"
      d="M5 12a7.5 7.5 0 0 1 7.5-7.5.5.5 0 0 0 0-1 8.5 8.5 0 0 0 0 17 .5.5 0 0 0 0-1A7.5 7.5 0 0 1 5 12"
    />
    <path
      fill="currentColor"
      d="M10.192 12.5h8.368l-1.966 1.966a.5.5 0 0 0-.162.35.5.5 0 0 0 .157.357.484.484 0 0 0 .713.006l2.614-2.613a.78.78 0 0 0 .242-.566.78.78 0 0 0-.242-.566l-2.614-2.613a.5.5 0 0 0-.36-.162.5.5 0 0 0-.354.168.48.48 0 0 0-.15.364.5.5 0 0 0 .15.338L18.56 11.5h-8.367a.48.48 0 0 0-.357.143.48.48 0 0 0-.143.357q0 .213.143.357a.48.48 0 0 0 .357.143"
    />
  </>
)
export default LogOut
